import { render } from "./CorrectionSession.vue?vue&type=template&id=f1607988&scoped=true&ts=true"
import script from "./CorrectionSession.vue?vue&type=script&lang=ts"
export * from "./CorrectionSession.vue?vue&type=script&lang=ts"

import "./CorrectionSession.vue?vue&type=style&index=0&id=f1607988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1607988"]])

export default __exports__